import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import fonts from 'src/constants/fonts';
import responsive from 'src/constants/responsive';

export type PanelTextProps = PanelTextDto;
const styles = {
    container: {
        [responsive.AfterTablet]: {
            maxWidth: '75%'
        },
        '& em': {
            ...fonts.FalsterGroteskLightItalic,
        },
        '& strong': {
            color: '#000',
            fontWeight: 'inherit'
        }
    }
};

type Props =
    PanelTextProps &
    StyledComponentProps<keyof typeof styles>;

const PanelText = (props: Props) => {
    const { classes } = props;
    return (
        <div className={classes!.container} dangerouslySetInnerHTML={{ __html: props.Text }} />
    );
}

export default withStyles(styles)(PanelText);


// WEBPACK FOOTER //
// ./src/components/PanelText.tsx